import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg aspect-[2/3] bg-background-200">
        <img
          src={movie.poster}
          alt={movie.title}
          title={`${movie.title} - 八戒影院高清在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

        {movie.isNew && (
          <span className="absolute top-2 left-2 bg-accent-500 text-foreground-950 text-xs font-bold px-2 py-0.5 rounded-md whitespace-nowrap">
            新
          </span>
        )}
        {movie.isHot && (
          <span className="absolute top-2 right-2 bg-primary-500 text-background-950 text-xs font-bold px-2 py-0.5 rounded-md whitespace-nowrap">
            热播
          </span>
        )}

        <div className="absolute bottom-0 left-0 right-0 p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="flex items-center gap-2 text-xs text-foreground-800">
            <span className="flex items-center gap-1">
              <i className="ri-star-fill text-primary-500 text-xs" />
              {movie.rating}
            </span>
            <span>{movie.year}</span>
            <span>{movie.type}</span>
          </div>
        </div>
      </div>

      <h3 className="mt-2 text-sm font-medium text-foreground-800 group-hover:text-primary-400 transition-colors line-clamp-1">
        {movie.title}
      </h3>
      <p className="text-xs text-foreground-500 mt-0.5">
        {movie.episodes}
      </p>
    </Link>
  );
}